/**
 * Invokes `onTick` every `intervalMs` until `stop()` is called. Used to
 * periodically refresh UI state derived from elapsed wall-clock time — e.g. a
 * "try again in ~X min" estimate counted down to a fixed deadline — which
 * would otherwise never recompute on its own: nothing about a Svelte
 * component naturally reacts to time passing without a page reload or
 * another state change.
 */
export function useTicker(intervalMs: number, onTick: () => void): { stop: () => void } {
  const timer = setInterval(onTick, intervalMs)
  return { stop: () => clearInterval(timer) }
}
